let runtimeStore = null;

export const setRuntimeStore = (store) => {
  runtimeStore = store;
};

export const getRuntimeStore = () => runtimeStore;
